export const sampleKpiData = {
  kpis: [
    {
      nombre: "Total de Activos",
      valor: 288,
      tendencia: [265, 270, 275, 282, 288],
      cambio: 8.3,
      unidad: "items",
      icono: "inventory"
    },
    {
      nombre: "Mantenimiento Pendiente",
      valor: 24,
      tendencia: [18, 22, 26, 25, 24],
      cambio: -4.0,
      unidad: "items",
      icono: "build"
    },
    {
      nombre: "Proyectos Activos",
      valor: 14,
      tendencia: [10, 12, 12, 13, 14],
      cambio: 7.7,
      unidad: "proyectos",
      icono: "assignment"
    },
    {
      nombre: "Tasa de Utilización",
      valor: 82.5,
      tendencia: [76.2, 78.5, 80.1, 81.8, 82.5],
      cambio: 2.1,
      unidad: "%",
      icono: "donutLarge"
    }
  ]
}; 